

<form
      
      name="form"
      (ngSubmit)="f.form.valid && onSubmit()"
      #f="ngForm"
      novalidate
      style="padding-left:50px;text-align: center;"
      [ng2-loading]="attemptingLogin"
    >

    <div class="row">
        <h3>Account Login</h3>
    </div>
    <div fxLayout="row">
      <mat-form-field style="margin-left: 25%;" fxFlex="50%" fxFlex.xs="100%" fxFlex.md="75%" class="form-group">
        <mat-label for="username">Email</mat-label>
        <input
          matInput 
          type="text"
          class="form-control"
          name="username"
          [(ngModel)]="form.username"
          required
          #username="ngModel"
        />
        <mat-error
          class="alert alert-danger"
          role="alert"
          *ngIf="username.errors && f.submitted"
        >
          Username is required!
        </mat-error>
      </mat-form-field>
    </div>
    <div fxLayout="row">
      <mat-form-field style="margin-left: 25%;" fxFlex="50%" fxFlex.xs="100%" fxFlex.md="75%" class="form-group">
        <mat-label for="password">Password</mat-label>
        <input
          matInput
          type="password"
          class="form-control"
          name="password"
          [(ngModel)]="form.password"
          required
          minlength="4"
          #password="ngModel"
        />
        <mat-error
          class="alert alert-danger"
          role="alert"
          *ngIf="password.errors && f.submitted"
        >
          <mat-error *ngIf="password.errors.required">Password is required</mat-error>
          <mat-error *ngIf="password.errors.minlength">
            Password must be at least 4 characters
          </mat-error>
        </mat-error>
      </mat-form-field>
    </div>
    
    <div style="padding:10px" class="form-group"  >
        <mat-error
          class="alert alert-danger"
          role="alert"
          *ngIf="f.submitted && isLoginFailed"
        >
          Login failed: {{ errorMessage }}
        </mat-error>
      </div>
      <div fxLayout="row">
      <div class="form-group" style="margin-left: 25%;" fxFlex="50%" fxFlex.xs="100%" fxFlex.md="75%">
        <a [routerLink]="'/forgotpassword'" style="float: left;">
                            Forgot Password?
                        </a>
        <button mat-raised-button style="float: right;">
          Login
        </button>
      </div>
    </div>
    </form>
